import { useEffect, useState } from 'react';
import { isRunningInBiltNativeShell } from '../utils/nativeShell';

// Match the tablet/desktop build layout. Phone landscape must not enable a kiosk.
const PHONE_BREAKPOINT = '(max-width: 767px)';

function available(): boolean {
  if (isRunningInBiltNativeShell() || document.documentElement.dataset.biltNativeShell) return false;
  if (window.matchMedia?.(PHONE_BREAKPOINT)?.matches) return false;

  // Some tablet browsers use an iPhone user agent; phones can request a desktop
  // one. Use the orientation-independent screen size when it is available.
  const shortSide = Math.min(window.screen.width, window.screen.height);
  const tabletScreen = shortSide >= 768;
  const touchScreen = navigator.maxTouchPoints > 0 || window.matchMedia?.('(pointer: coarse)')?.matches;
  if (touchScreen && shortSide > 0 && !tabletScreen) return false;
  return tabletScreen || !/iPhone|iPod|Android.*Mobile/i.test(navigator.userAgent);
}

/** Show Mode is a browser presentation for desktop and tablet screens. */
export function useCarShowAvailable(): boolean {
  const [allowed, setAllowed] = useState(available);
  useEffect(() => {
    const media = window.matchMedia?.(PHONE_BREAKPOINT);
    const update = () => setAllowed(available());
    media?.addEventListener('change', update);
    window.addEventListener('bilt-native-shell-ready', update);
    update();
    return () => {
      media?.removeEventListener('change', update);
      window.removeEventListener('bilt-native-shell-ready', update);
    };
  }, []);
  return allowed;
}
